// imports
import Component from 'minsky-kit/js/components/Component';
import gsap from 'gsap';

// private statics

// class definition
export default class ContactForm extends Component {
    // constructor
    constructor (args = {}, objectName = 'ContactForm') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // properties
        this._$formWrapper = this.$el.querySelector('.contact-form-block__form');
        this._hasMouseIn = false;
        this._hasFocus = false;

        if (this._$formWrapper) {
            gsap.set(this._$formWrapper, { height: 0, opacity: 0 });

            // add listeners
            this.$el.addEventListener('mouseenter', this.blm.add('mouseenter', onMouseIn));
            this.$el.addEventListener('mouseleave', this.blm.add('mouseleave', onMouseOut));

            this._$formWrapper.querySelectorAll('input,select,textaria,button').forEach(($item) => {
                $item.addEventListener('focusin', this.blm.addOnce('focusin', onFieldFocusIn));
                $item.addEventListener('focusout', this.blm.addOnce('focusout', onFieldFocusOut));
            });
        }
    }

    // methods

    destroy () {
        if (this._$formWrapper) {
            this.$el.removeEventListener('mouseenter', this.blm.remove('mouseenter'));
            this.$el.removeEventListener('mouseleave', this.blm.remove('mouseleave'));

            this._$formWrapper.querySelectorAll('input,select,textaria,button').forEach(($item) => {
                $item.removeEventListener('focusin', this.blm.removeOnce('focusin'));
                $item.removeEventListener('focusout', this.blm.removeOnce('focusout'));
            });
        }

        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
function open (e) {
    gsap.to(this._$formWrapper, {
        height: this._$formWrapper.scrollHeight, opacity: 1, duration: 0.5, ease: 'sine-ease-out',
    });
}

function close (e) {
    gsap.to(this._$formWrapper, {
        height: 0, opacity: 0, duration: 0.5, ease: 'sine-ease-out',
    });
}

function onMouseIn (e) {
    this._hasMouseIn = true;

    if (!this._hasFocus) {
        open.call(this);
    }
}

function onMouseOut (e) {
    this._hasMouseIn = false;

    if (!this._hasFocus) {
        close.call(this);
    }
}

function onFieldFocusIn () {
    this._hasFocus = true;

    if (!this._hasMouseIn) {
        open.call(this);
    }
}

function onFieldFocusOut () {
    this._hasFocus = false;

    if (!this._hasMouseIn) {
        close.call(this);
    }
}
